import { ChevronDown } from 'react-feather';

import Pagination from '@/shared/components/UI/Pagination';
import ProductCard from '@/shared/components/UI/ProductCard';
import Button from '@/shared/components/UI/Button';

import { useProductList } from '../hooks/useProductList';

const ProductList = () => {
  const {
    // State
    product,
    totalCount,
    stockStatus,
    sort,
    stockDropdown,
    sortDropdown,

    // Event handlers
    handleStockStatusChange,
    handleSortChange,

    // Utility functions
    getCategoryName,
    getStockStatusLabel,
    getSortLabel,
  } = useProductList();
  return (
    <>
      <section className="mx-auto mb-10 mt-[68px] max-w-5xl">
        <h3 className="text-center text-[24px] font-black text-[#95699f]">
          {getCategoryName()}
        </h3>
        <div className="mx-auto my-10 flex justify-between">
          {/* Selectbox 1 - Stock Status */}
          <div className="relative cursor-pointer">
            <div
              className="flex h-9 w-[140px] items-center justify-between px-4 py-2"
              onClick={stockDropdown.toggle}
              role="button"
              tabIndex={0}
              onKeyDown={stockDropdown.handleKeyDown}
              aria-haspopup="listbox"
              aria-expanded={stockDropdown.isOpen}
            >
              <div className="text-[14px] font-medium tracking-wider text-[#444]">
                {getStockStatusLabel(stockStatus)}
              </div>
              <div className="flex items-center">
                <ChevronDown
                  size={16}
                  color="#666666"
                  strokeWidth={2}
                  className={`transition-transform duration-200 ${stockDropdown.isOpen ? 'rotate-180' : ''}`}
                />
              </div>
            </div>
            <ul
              className={`absolute z-[100] mt-1 w-[140px] overflow-hidden rounded-lg bg-[#fff] p-0 transition-all duration-300 ease-in ${
                stockDropdown.isOpen ? 'max-h-48 shadow-lg' : 'max-h-0'
              }`}
            >
              <li>
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() => handleStockStatusChange('all')}
                  className="h-auto w-full justify-start rounded-lg px-3 py-3 text-[12px] font-normal tracking-wider hover:bg-[#f6f6f6] active:bg-[#b995be40]"
                >
                  ALL
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() => handleStockStatusChange('inStock')}
                  className="h-auto w-full justify-start rounded-lg px-3 py-3 text-[12px] font-normal tracking-wider hover:bg-[#f6f6f6] active:bg-[#b995be40]"
                >
                  In stock
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() => handleStockStatusChange('outOfStock')}
                  className="h-auto w-full justify-start rounded-lg px-3 py-3 text-[12px] font-normal tracking-wider hover:bg-[#f6f6f6] active:bg-[#b995be40]"
                >
                  Out of stock
                </Button>
              </li>
            </ul>
          </div>
          {/* Selectbox 2 - Sort */}
          <div className="relative cursor-pointer">
            <div
              className="flex h-9 w-[140px] items-center justify-between px-4 py-2"
              onClick={sortDropdown.toggle}
              role="button"
              tabIndex={0}
              onKeyDown={sortDropdown.handleKeyDown}
              aria-haspopup="listbox"
              aria-expanded={sortDropdown.isOpen}
            >
              <div className="text-[14px] font-medium tracking-wider text-[#444]">
                {getSortLabel(sort)}
              </div>
              <div className="flex items-center">
                <ChevronDown
                  size={16}
                  color="#666666"
                  strokeWidth={2}
                  className={`transition-transform duration-200 ${sortDropdown.isOpen ? 'rotate-180' : ''}`}
                />
              </div>
            </div>
            <ul
              className={`absolute z-[100] mt-1 w-[140px] overflow-hidden rounded-lg bg-[#fff] p-0 transition-all duration-300 ease-in ${
                sortDropdown.isOpen ? 'max-h-48 shadow-lg' : 'max-h-0'
              }`}
            >
              <li>
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() => handleSortChange('latest')}
                  className="h-auto w-full justify-start rounded-lg px-3 py-3 text-[12px] font-normal tracking-wider hover:bg-[#f6f6f6] active:bg-[#b995be40]"
                >
                  Latest
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() => handleSortChange('bestSelling')}
                  className="h-auto w-full justify-start rounded-lg px-3 py-3 text-[12px] font-normal tracking-wider hover:bg-[#f6f6f6] active:bg-[#b995be40]"
                >
                  Best Selling
                </Button>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-4">
          {product.map((products) => (
            <ProductCard product={products} key={products.productUuid} />
          ))}
        </div>
      </section>
      <Pagination totalCount={totalCount} />
    </>
  );
};

export default ProductList;
